// When live site switch to myerpbaseurl
//export const BASE_URL = "http://13.211.153.73:3000/";

//For live site
//export const BASE_URL = "http://localhost:3000/";
// export const BASE_URL = 'https://myerp.herokuapp.com/';
//export const BASE_URL = 'https://fberp.firebrandbbq.com.au/';

// added cloud distribution id
export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
